module.exports = __webpack_public_path__ + "img/icon-6.894202f3.svg";